function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15V35C29 42.732 22.732 49 15 49C7.26801 49 1 42.732 1 35V15Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 1.23125,
  y: 1.23125,
  width: 27.5375,
  height: 47.5375,
  rx: 13.7688,
  stroke: "#6C8936",
  strokeWidth: 2.4625
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 12.4813,
  y: 11.2313,
  width: 5.0375,
  height: 10.0375,
  rx: 2.51875,
  fill: "#6C8936",
  stroke: "#6C8936",
  strokeWidth: 2.4625
});

function SvgMouseControlZoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 50,
    viewBox: "0 0 30 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseControlZoom);
export default __webpack_public_path__ + "static/media/mouse-control-zoom.4c5c113e.svg";
export { ForwardRef as ReactComponent };